import { Component, OnInit, Input, ViewEncapsulation, OnChanges} from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { PeopleProfileHelpModalComponent } from "../../components/people-profile-help-modal/people-profile-help-modal.component";
import { PermissionsService } from "../../services/permissions/permissions.service";
import moment from 'moment';
import { ReferencesService } from 'src/app/services/references/references.service';
import { ReferenceModalComponent } from '../reference-modal/reference-modal.component';
import {AlertBannerService, AlertType} from 'src/app/lib/alert-banner';
import { PlanService } from 'src/app/services/plan-status/plan-status.service';
import { RequestService } from 'src/app/services/request/request.service';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import * as Cookies from "js-cookie";

@Component({
  selector: 'app-people-profile-reports',
  templateUrl: './people-profile-reports.component.pug',
  styleUrls: ['./people-profile-reports.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PeopleProfileReportsComponent implements OnInit, OnChanges {
  @Input() reports: any;
  @Input() details: any;
  @Input() page: any;
  @Input() ref_id: any;
  @Input() profileStatus: any;
  moment: any;
  peopleProfileHelpModal: BsModalRef;
  profileParam = { s: 'profile' };
  referenceModal: any;
  loading: any = false;
  cancelledBy = $localize`Cancelled by`
  cancelled = $localize`Cancelled`
  noPlanText = $localize`No active plan`
  REHIRE_STATUS = [
    { 'label': $localize`Hire`, 'value': 'Hire' },
    { 'label': $localize`Declined to answer`, 'value': 'Declined to answer' },
    { 'label': $localize`Do not hire`, 'value': 'Do not hire' },
    { 'label': $localize`Inconsistent`, 'value': 'Inconsistent' }
  ]
  PULSE_STATUS_MAPPING = {
      1: 'Stopped',
      2: 'Sending',
      3: 'In progress',
      5: 'Completed',
  };
  STATUS_OPTIONS = [
    { 'label': $localize`Invited`, 'value': 'Invited' },
    { 'label': $localize`In progress`, 'value': 'In progress' },
    { 'label': $localize`Submitted`, 'value': 'Submitted' },
    { 'label': $localize`Verified`, 'value': 'Verified' },
    { 'label': $localize`Declined`, 'value': 'Declined' },
    { 'label': $localize`Expired`, 'value': 'Expired' },
    { 'label': $localize`Completed`, 'value': 'Completed' },
    { 'label': $localize`Requested`, 'value': 'Requested' },
    { 'label': $localize`Deleted`, 'value': 'Deleted' },
    { 'label': $localize`Stopped`, 'value': 'Stopped' },
    { 'label': $localize`Scheduled`, 'value': 'Scheduled' },
    { 'label': $localize`Sending`, 'value': 'Sending' },
    { 'label': $localize`Cancelled`, 'value': 'Cancelled' },
    { 'label': $localize`Failed`, 'value': 'Failed' },
  ];

  STATUS_OPTIONS_CHECKS = [
    { 'label': $localize`Invited`, 'value': 'Invited' },
    { 'label': $localize`In progress`, 'value': 'In progress' },
    { 'label': $localize`Submitted`, 'value': 'Submitted' },
    { 'label': $localize`Verified`, 'value': 'Verified' },
    { 'label': $localize`Declined`, 'value': 'Declined' },
    { 'label': $localize`Expired`, 'value': 'Expired' },
    { 'label': $localize`Completed`, 'value': 'Completed' },
    { 'label': $localize`Requested`, 'value': 'Requested' },
    { 'label': $localize`Deleted`, 'value': 'Deleted' },
    { 'label': $localize`Stopped`, 'value': 'Stopped' },
    { 'label': $localize`Scheduled`, 'value': 'Scheduled' },
    { 'label': $localize`Sending`, 'value': 'Sending' },
    { 'label': $localize`Cancelled`, 'value': 'Cancelled' },
    { 'label': $localize`Failed`, 'value': 'Failed' },
    { 'label': $localize`Purged`, 'value': 'Purged' },
  ];
  subStatusTooltips = {
    delayed: $localize`Processing of this background check is delayed as it is undergoing manual review.`,
    dco: $localize`This background check has been flagged for your review.`,
    purged: $localize`The background check has been removed by the vendor to comply with legal requirements and is no longer accessible.`,
  }
  COMPLETED_OR_STOPPED = ['Completed', 'Stopped'];
  MOBILE_ID_FLOWS = ['ID - 1 doc', 'ID - 1 doc + DVS', 'ID - 2 docs', 'ID - 2 docs + DVS']

  TrustEIVC = false;
  lastActivity = $localize`Last activity`
  noneProductPermissionTooltips: { [key: string]: string } = {
    'Reference': ConstantsService.REFERENCE_NONE_TOOLTIP,
    'Reference Integration': ConstantsService.INTEGRATION_NONE_TOOLTIP,
    'Background check': ConstantsService.BACKGROUND_CHECK_NONE_TOOLTIP,
    'Pulse': ConstantsService.PULSE_CHECK_NONE_TOOLTIP,
    'Exit': ConstantsService.EXIT_CHECK_NONE_TOOLTIP,
  };
  restrictedProductPermissionTooltips: { [key: string]: string } = {
    'Reference': ConstantsService.REFERENCE_RESTRICTED_TOOLTIP,
    'Reference Integration': '',
    'Background check': '',
    'Pulse': ConstantsService.PULSE_RESTRICTED_TOOLTIP,
    'Exit': ConstantsService.EXIT_RESTRICTED_TOOLTIP,
  };

  canViewBackGroundReport = false;
  compWindow: any;
  readonly ActivityRole = {
    Exitee: 0,
    Pulsee: 1,
    Manager: 2,
    Candidate: 3,
    Referee: 4,
    None: 5,
  } as const;

  constructor(
    private modalService: BsModalService,
    private router: Router,
    private permissions: PermissionsService,
    private referencesService: ReferencesService,
    private planService: PlanService,
    public requestService: RequestService,
    private alertList: AlertBannerService
  ) {
    this.peopleProfileHelpModal = new BsModalRef();
    this.TrustEIVC = this.permissions.isFeatureActivated('trust-892-eivc');
    this.canViewBackGroundReport = (
      this.permissions.hasPermission('can_manage_backgroundcheck_requests') ||
      this.permissions.hasPermission('can_manage_backgroundcheck_requests_with_survey_perms') ||
      this.permissions.hasPermission('can_manage_own_backgroundcheck_requests') ||
      this.permissions.hasPermission('can_manage_support_background_checks')
    )
  }

  ngOnChanges(): void {
    this.convertData();
  }
  ngOnInit(): void {
    if(this.page === 'referenceReportPage' && this.ref_id ) {
      this.onViewReferenceReport(false, this.ref_id)
    }

    this.compWindow = window;
  }

  convertData() {
    this.reports.forEach(report => {
      this.processCheckType(report)
    })

  }

  convertDataPulse(report){
    if (report.scheduled_time) {
      let scheduled_date = moment(report.scheduled_time)
      report.scheduled_time = scheduled_date.format('ll')
    }
    if (report.state == 0 && report.scheduled_time) {
      report.current_state = $localize`Scheduled`
      report.current_count = report.stats.total_recipients
    } else if (report.state == 1) {
      report.current_state = $localize`Stopped`
      report.current_count = `${report.stats.total_completed+report.stats.total_declined}/${report.stats.total_recipients}`
    } else if (report.state == 2 || (report.state == 0 && !report.scheduled_time)) {
      report.current_state = $localize`Sending`
      report.current_count = report.stats.total_recipients
    } else if (report.state == 3) {
      report.current_state = $localize`In progress`
      report.current_count =  `${report.stats.total_completed+report.stats.total_declined}/${report.stats.total_recipients}`
    } else if (report.state == 5) {
      report.current_state = $localize`Completed`
      report.current_count = `${report.stats.total_completed+report.stats.total_declined}/${report.stats.total_recipients}`
    } else if (report.state == 6 || report.state == 7) {
      report.current_state = $localize`Cancelled`
    }
  }

  setStatusColour(report) {
    if (report.status === 'Submitted' || report.status === 'Verified' || report.status === 'Completed') {
      report.status_colour = 'green';
      if (report.status === "Verified") {
        report.icon = "success";
      }
    }
    else if (report.status === 'In progress') {
      report.status_colour = 'yellow';
    }
    else if (report.status === 'Declined' || report.status === 'Expired' || report.status === 'Stopped') {
      report.status_colour = 'red';
    }
    else if (report.status === 'Invited' || report.status === 'Requested') {
      report.status_colour = 'grey';
    }
  }

  showHelp() {
    this.peopleProfileHelpModal = this.modalService.show(PeopleProfileHelpModalComponent, {
      class: 'modal-dialog-centered modal-lg'
    });
  }

  onViewReport(id) {
      this.loading = true
      this.referencesService.getCheck(id).subscribe(
      res=>{
        this.loading = false
        const initialState={
          'check': res
        }
        this.referenceModal = this.modalService.show(ReferenceModalComponent,{
          class: 'modal-dialog-scrollable reference-modal modal-lg', initialState
        })
      },
      error=>{
        this.loading = false
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      });
  }

  onViewReferenceReport(restricted, id, report?: any) {
    if (!restricted) {
      if (!report || report?.activity_role === this.ActivityRole.Referee) {
        this.loading = true;
        this.referencesService.getCheck(id).subscribe(
          res => {
            this.loading = false;

            // Match referee email (case-insensitive, null-safe)
            let email = this.details?.email?.trim().toLowerCase();

            // If email is null/empty, fallback to personal, then work
            if (!email) {
              const personal = this.details?.emails_with_types?.personal?.trim().toLowerCase();
              const work = this.details?.emails_with_types?.work?.trim().toLowerCase();

              email = personal || work;
            }

            // Find the referee with matching email
            const matchingReferee = res?.xref?.referees?.find(referee =>
              referee?.email?.trim().toLowerCase() === email
            );

            if (matchingReferee) {
              const locale = (Cookies.get(ConstantsService.XREF_LOCALE) || 'EN-AU').toUpperCase();
              // Redirect to the specific referee report URL
              this.compWindow.location.href = `${this.compWindow.location.origin}/${locale}/reference-report/${id}/referee/${matchingReferee.id}`;
            } else {
              console.warn('No matching referee found for referee with email:', email);
            }
          },
          error => {
            this.loading = false;
            console.log(error);
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
          }
        );
      } else {
        this.loading = true
        this.referencesService.getCheck(id).subscribe(
          res => {
            this.loading = false
            const initialState = {
              'check': res
            }
            this.referenceModal = this.modalService.show(ReferenceModalComponent, {
              class: 'modal-dialog-scrollable reference-modal modal-lg', initialState
            })
          },
          error => {
            this.loading = false
            console.log(error);
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
          });
      }
    }
  }

  statusSelectAssign(request, inputClass) {
    let isExpired = moment.utc(request.expiry) < moment.utc(new Date())
    if (request.status == 'Invited' || request.status == 'In progress' || (request.status == 'Invited' && request.total_completed < 5)) {
      if (inputClass === 'status-select') {
        return 'status-select-wheat'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-wheat';
      }
      else if (inputClass == 'internal-pill') {
        return 'internal-pill-wheat'
      }
    }
    else if ((request.status == 'Invited' && request.total_completed > 5) || (request.status == 'Submitted' && (request.total_completed == request.total_sent || (request.total_completed >= 5 && isExpired))) || (request.status == 'Expired' && request.total_completed >= 5)) {
      if (inputClass === 'status-select') {
        return 'status-select-green'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-green';
      }
      else if (inputClass == 'internal-pill') {
        return 'internal-pill-green'
      }
    }
    else if ((request.status == 'Invited' && request.total_completed > 5) || (request.status == 'Submitted' && (request.total_completed < 5 && isExpired)) || (request.status == 'Expired' && (request.total_completed < 5 || request.total_completed == 0))) {
      if (inputClass === 'status-select') {
        return 'status-select-black'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-black';
      }
      else if (inputClass == 'internal-pill') {
        return 'internal-pill-black'
      }
    }
    else if (request.status == 'Expired') {
      if (inputClass === 'status-select') {
        return 'status-select-black'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-black';
      }
      else if (inputClass == 'internal-pill') {
        return 'internal-pill-black'
      }
    }
    else if (request.status == 'Declined') {
      if (inputClass === 'status-select') {
        return 'status-select-black'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-black';
      }
      else if (inputClass == 'internal-pill') {
        return 'internal-pill-black'
      }
    }
    return 'true'
  }

  statusSelectAssignPulse(request, inputClass) {
    // As cleanup is hard in pug file, keeping function selection logic here
    return this.statusSelectAssignPulseV1(request, inputClass);
  }

  statusSelectAssignPulseV1(request, inputClass) {
    const selectedExpiry = request.stats.expiry;
    let isExpired = moment.utc(selectedExpiry) < moment.utc(new Date());
    if(request.state==0 || request.state==2
    || (request.state==3 && !isExpired && request.stats.total_completed < request.stats.total_sent)) {
      if(inputClass === 'status-select') {
        return 'status-select-wheat'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-wheat';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-wheat'
      }
    }
    else if((request.state==5 && (request.stats.total_completed==request.stats.total_sent
      || (isExpired && request.stats.total_completed>=5 ))) || (request.state==1 && request.stats.total_completed>=5)) {
      if(inputClass === 'status-select') {
        return 'status-select-green'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-green';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-green'
      }
    }
    else if((request.state==3 && request.stats.total_completed>5)
    || (request.state==5 && (request.stats.total_completed<5) && isExpired)
    || (request.state==1 && (request.stats.total_completed<5 || request.stats.total_completed==0))) {
      if(inputClass === 'status-select') {
        return 'status-select-black'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-black';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-black'
      }
    }
    else if(request.state==7 || request.state==6) {
      if(inputClass === 'status-select') {
        return 'status-select-black'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-black';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-black'
      }
    }
  return 'true'
  }

  deprecatedStatusSelectAssignPulse(request, inputClass) {
    if(request.state==0 || request.state==2 || (request.state==3 && (request.stats.total_completed)<5)) {
      if(inputClass === 'status-select') {
        return 'status-select-wheat'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-wheat';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-wheat'
      }
    }
    else if((request.state==3 && (request.stats.total_completed)>=5) || (request.state==5 && (request.stats.total_completed==request.stats.total_sent || (request.stats.total_completed>=5))) || (request.state==1 && request.stats.total_completed>=5)) {
      if(inputClass === 'status-select') {
        return 'status-select-green'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-green';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-green'
      }
    }
    else if((request.state==3 && request.stats.total_completed>5) || (request.state==5 && (request.stats.total_completed<5)) || (request.state==1 && (request.stats.total_completed<5 || request.stats.total_completed==0))) {
      if(inputClass === 'status-select') {
        return 'status-select-black'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-black';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-black'
      }
    }
    else if(request.state==7 || request.state==6) {
      if(inputClass === 'status-select') {
        return 'status-select-black'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-black';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-black'
      }
    }
  return 'true'
  }

  createHTML(request) {
    if (request.status == 'Deleted') {
      let mainString = ''
      const string = `<div class="pill-state"><p class="pill-text">${this.cancelledBy} ${request.updated_by}</p></div>
                      <p class="internal-date">${request.last_activity}</p>`
      mainString += string
      return mainString
    } else if (request.status == 'Expired') {
      let mainString = ''
      const string = `<div class="pill-state"><p class="pill-text">${this.cancelled}</p></div>
                      <p class="internal-date">${this.noPlanText}</p>`
      mainString += string
      return mainString
    }
    else {
      let dummyArray = [{ "type": $localize`Submitted`, "count": request.stats.total_completed }, { "type": $localize`Declined`, "count": request.stats.total_declined }]
      let mainString = ''
      for (let i = 0; i < dummyArray.length; i++) {
        if (dummyArray[i]['type'] == 'Declined') {
          const string = `<div class="pill-state"><p class="pill-text">Declined</p><div class="inner-pill-circle"><p class="inner-pill-number">${dummyArray[i]['count']}</p></div></div>`
          mainString += string
        }
        else if ((dummyArray[i]['type'] == 'Submitted')) {
          const string = `<div class="pill-state"><p class="pill-text">Submitted</p><div class="inner-pill-circle-green"><p class="inner-pill-number-green">${dummyArray[i]['count']}</p></div></div>`
          mainString += string
        }
      }
      return mainString
    }
  }

  handleCheckType(report: any): void {
    switch (report.check_type) {
      case 'Reference':
        this.handleReferenceCheck(report);
        break;
      case 'Pulse':
        this.handlePulseCheck(report);
        break;
      case 'Exit':
        this.handleExitCheck(report);
        break;
      case 'Background check':
        this.handleBackgroundCheck(report);
        break;
      default:
        break;
    }
  }

  processCheckType(report: any): void {
    switch (report.check_type) {
      case 'Reference':
      case 'Reference Integration':
        this.processReferenceAndIntegrationCheck(report);
        break;
      case 'Pulse':
        this.processPulseCheck(report);
        break;
      case 'Exit':
        this.processExitCheck(report);
        break;
      case 'Background check':
        this.processBackgroundCheck(report);
        break;
      default:
        break;
    }
  }

  formatDate(date: any): string {
    return date ? moment(date).format('ll') : '-';
  }

  handleReferenceCheck(report: any) {
    report.last_activity = this.formatDate(report.last_activity);
    report.referees = report.referees || '-';
    report.competencies = report.competencies ? `${report.competencies} / 7` : '-';

    const { start, end } = report.reference_coverage;
    if (start === null && end === null) {
      report.reference_coverage = '-';
      report.referenceCoverageRange = '-';
    } else {
      const startDate = moment(new Date(`${start.year}-${start.month}-${start.day}`)).format('ll');
      const endDate = moment(new Date(`${end.year}-${end.month}-${end.day}`)).format('ll');
      report.referenceCoverageRange = `${startDate} - ${endDate}`;
    }

    switch (report.unusual_activity) {
      case 1:
        report.unusual_activity = true;
        report.unusual_activity_bg = 'yellow';
        break;
      case 2:
        report.unusual_activity = true;
        report.unusual_activity_bg = 'red';
        break;
      default:
        report.unusual_activity = false;
        report.unusual_activity_bg = '';
    }

    report.top_row = [
      { label: $localize`Requested by`, content: report.requested_by }
    ];
    report.tag_information = {
      hasTag: true,
      nestedStatTagText: '',
      tagText: this.getLabelByValue(report.status),
      status: report.status,
      tagCompleted: 0,
      tagTotal: 0,
    };
    report.bottom_row = [
      { label: $localize`Reference coverage`, content: report.referenceCoverageRange },
      { label: $localize`Referees`, content: report.referees },
      { label: $localize`Competencies score`, content: report.competencies },
    ];
  }

  processReferenceAndIntegrationCheck(report: any) {
    report.questionnaire_name = report.restricted ? ConstantsService.REFERENCE_RESTRICTED : report.questionnaire_name;
    report.last_activity = this.formatDate(report.last_activity);
    report.top_row = [
      { label: $localize`Requested by`, content: report.requested_by }
    ];
    report.top_row_grid_label = $localize`Last activity`;
    if (report.product_permission) {
      report.referees = report.referees || '-';
      report.competencies = report.competencies ? `${report.competencies} / 7` : '-';

      const { start, end } = report.reference_coverage;
      if (start === null && end === null) {
        report.reference_coverage = '-';
        report.referenceCoverageRange = '-';
      } else {
        const startDate = moment(new Date(`${start.year}-${start.month}-${start.day}`)).format('ll');
        const endDate = moment(new Date(`${end.year}-${end.month}-${end.day}`)).format('ll');
        report.referenceCoverageRange = `${startDate} - ${endDate}`;
      }

      switch (report.unusual_activity) {
        case 1:
          report.unusual_activity = true;
          report.unusual_activity_bg = 'yellow';
          break;
        case 2:
          report.unusual_activity = true;
          report.unusual_activity_bg = 'red';
          break;
        default:
          report.unusual_activity = false;
          report.unusual_activity_bg = '';
      }

      report.tag_information = {
        hasTag: true,
        nestedStatTagText: '',
        tagText: this.getLabelByValue(report.status),
        status: report.status,
        tagCompleted: 0,
        tagTotal: 0,
      };
      report.bottom_row = [
        { label: $localize`Referees`, content: report.referees },
        { label: $localize`Competencies score`, content: report.competencies },
        { label: $localize`Reference coverage`, content: report.referenceCoverageRange },
      ];
      report.view_info = {
        enabled: !report.restricted,
        hidden: false,
        tooltip: report.restricted ? this.getTooltip(report.check_type, true) : '',
        btnText: $localize`View`
      }
      if (report?.activity_role == this.ActivityRole.Referee) {
        report.top_row_grid_label = $localize`Reference coverage`
        report.top_row = [
          {label: $localize`Referee for`, content: report.referee_for || '-' }
        ];
        report.questionnaire_name = report.restricted ? ConstantsService.POTENTIAL_CANDIDATE_RESTRICTED : report.questionnaire_name;
      }
    }
    else {
      if (report?.activity_role == this.ActivityRole.Referee) {
        this.setReferenceCoverageRange(report);
        report.top_row_grid_label = $localize`Reference coverage`
        report.top_row = [
          {label: $localize`Referee for`, content: report.referee_for || '-' }
        ];
        report.questionnaire_name = report.restricted ? ConstantsService.POTENTIAL_CANDIDATE_RESTRICTED : report.questionnaire_name;
      }
      this.setTagButtonInfoForNoPermissions(report);
    }
  }

  setReferenceCoverageRange(report: any): void {
    const { start = null, end = null } = report.reference_coverage || {};

    if (start === null && end === null) {
      report.reference_coverage = '-';
      report.referenceCoverageRange = '-';
    } else {
      const startDate = moment(new Date(`${start.year}-${start.month}-${start.day}`)).format('ll');
      const endDate = moment(new Date(`${end.year}-${end.month}-${end.day}`)).format('ll');
      report.referenceCoverageRange = `${startDate} - ${endDate}`;
    }
  }

  setTagButtonInfoForNoPermissions(report){
    report.tag_information = {
      hasTag: false,
      nestedStatTagText: '',
      tagText: '',
      status: '',
      tagCompleted: 0,
      tagTotal: 0,
    }
    report.bottom_row = []
    report.view_info = {
      enabled: false,
      hidden: false,
      tooltip: this.getTooltip(report.check_type, report.product_permission),
      btnText: $localize`View`
    }
  }

  getTooltip(checkType: string, hasProductPermissions: boolean){
    if (hasProductPermissions) {
      return this.restrictedProductPermissionTooltips[checkType]
    } else {
      return this.noneProductPermissionTooltips[checkType]
    }
  }

  handlePulseCheck(report: any) {
    report.last_activity = this.formatDate(report.last_activity);
    report.status = this.PULSE_STATUS_MAPPING[report.state] || report.status
    report.top_row = [
      { label: $localize`Created by`, content: report.requested_by }
    ];

    const { isReportViewAllowed, tooltipText, isInsightsNotAvailable } = this.processReport(report);
    report.is_report_view_allowed = isReportViewAllowed

    report.tag_information = {
      hasTag: true,
      nestedStatTagText: '',
      tagText: this.getLabelByValue(report.status),
      status: report.status,
      tagCompleted: report.stats.total_completed + report.stats.total_declined,
      tagTotal: report.stats.total_recipients,
      pulseCutoffIncomplete: isInsightsNotAvailable
    };

    // Update 'report.tag_information' properties based on 'Sending' status for component library
    if (report.status == 'Sending'){
      report.tag_information.nestedStatTagText = report.stats.total_recipients
      report.tag_information.tagTotal = -1
    }

    report.view_info = {
      enabled: isReportViewAllowed,
      hidden: false,
      tooltip: tooltipText,
      btnText: $localize`View`
    }

    report.pulse_status_tooltip = [
      {label: $localize`Submitted`, content: `${report.stats.total_completed}/${report.stats.total_recipients}`, colour: 'forest'},
      {label: $localize`Declined`, content: `${report.stats.total_declined}/${report.stats.total_recipients}`},
    ];
  }

  processPulseCheck(report: any) {
    report.questionnaire_name = report.restricted ? ConstantsService.PULSE_RESTRICTED : report.questionnaire_name;
    report.last_activity = this.formatDate(report.last_activity);
    report.top_row = [
      { label: $localize`Created by`, content: report.requested_by }
    ];
    if (report.product_permission) {
      report.status = this.PULSE_STATUS_MAPPING[report.state] || report.status
      const { isReportViewAllowed, tooltipText, isInsightsNotAvailable } = this.processReport(report);
      report.is_report_view_allowed = report.restricted ? false : isReportViewAllowed;

      report.tag_information = {
        hasTag: true,
        nestedStatTagText: '',
        tagText: this.getLabelByValue(report.status),
        status: report.status,
        tagCompleted: report.stats.total_completed + report.stats.total_declined,
        tagTotal: report.stats.total_recipients,
        pulseCutoffIncomplete: isInsightsNotAvailable
      };

      // Update 'report.tag_information' properties based on 'Sending' status for component library
      if (report.status == 'Sending'){
        report.tag_information.nestedStatTagText = report.stats.total_recipients
        report.tag_information.tagTotal = -1
      }

      report.view_info = {
        enabled: report.restricted ? false : isReportViewAllowed,
        hidden: false,
        tooltip: report.restricted ? this.getTooltip(report.check_type, true) : tooltipText,
        btnText: $localize`View`
      }

      report.pulse_status_tooltip = [
        {label: $localize`Submitted`, content: `${report.stats.total_completed}/${report.stats.total_recipients}`, colour: 'forest'},
        {label: $localize`Declined`, content: `${report.stats.total_declined}/${report.stats.total_recipients}`},
      ];
    }
    else {
      report.is_report_view_allowed = false;
      this.setTagButtonInfoForNoPermissions(report);
    }
  }

  handleExitCheck(report: any) {
    report.last_activity = this.formatDate(report.last_activity);
    report.rehire_recommendation = !report.rehire_recommendation ? '-' : this.REHIRE_STATUS.find(status => status.value === report.rehire_recommendation)?.label;
    report.skills = report.skills ? `${report.skills.toFixed(1)} / 5` : '-';
    report.competencies = report.competencies ? `${report.competencies.toFixed(1)} / 5` : '-';
    report.top_row = [
      { label: $localize`Requested by`, content: report.requested_by }
    ];

    report.tag_information = {
      hasTag: true,
      nestedStatTagText: '',
      tagText: this.getLabelByValue(report.status),
      status: report.status,
      tagCompleted: 0,
      tagTotal: 0,
    };
    report.bottom_row = [
      { label: $localize`Skills score`, content: report.skills },
      { label: $localize`Competencies score`, content: report.competencies },
      { label: $localize`Rehire recommendation`, content: report.rehire_recommendation },
    ];
    report.view_info = {
      enabled: ['Submitted', 'Verified'].includes(report.status),
      hidden: false,
      btnText: $localize`View`
    }
  }

  processExitCheck(report: any) {
    report.questionnaire_name = report.restricted ? ConstantsService.EXIT_RESTRICTED : report.questionnaire_name;
    report.top_row = [
      { label: $localize`Requested by`, content: report.requested_by }
    ];
    report.last_activity = this.formatDate(report.last_activity);
    if (report.product_permission) {
      report.rehire_recommendation = !report.rehire_recommendation ? '-' : this.REHIRE_STATUS.find(status => status.value === report.rehire_recommendation)?.label;
      report.skills = report.skills ? `${report.skills.toFixed(1)} / 5` : '-';
      report.competencies = report.competencies ? `${report.competencies.toFixed(1)} / 5` : '-';

      report.tag_information = {
        hasTag: true,
        nestedStatTagText: '',
        tagText: this.getLabelByValue(report.status),
        status: report.status,
        tagCompleted: 0,
        tagTotal: 0,
      };
      report.bottom_row = [
        { label: $localize`Skills score`, content: report.skills },
        { label: $localize`Competencies score`, content: report.competencies },
        { label: $localize`Rehire recommendation`, content: report.rehire_recommendation },
      ];
      report.view_info = {
        enabled: report.restricted ? false : ['Submitted', 'Verified'].includes(report.status),
        hidden: false,
        tooltip: report.restricted ? this.getTooltip(report.check_type, true) : '',
        btnText: $localize`View`
      }
    } else {
      this.setTagButtonInfoForNoPermissions(report);
    }
  }

  handleBackgroundCheck(report:any){
    report.last_activity = this.formatDate(report.last_activity);
    report.top_row = [
      { label: $localize`Requested by`, content: report.requested_by }
    ];
    report.check_name = this.MOBILE_ID_FLOWS.includes(report.check_name) ? `MobileID - ${report.check_name}` : report.check_name;
    report.tag_information = {
      hasTag: true,
      nestedStatTagText: '',
      tagText: this.getLabelByValue(report.status),
      status: report.status,
      tagCompleted: 0,
      tagTotal: 0,
    };
    report.view_info = {
      enabled: !!report?.report_url && this.canViewBackGroundReport && !report?.sub_status?.purged,
      hidden: false,
      btnText: $localize`View`
    }
  }

  processBackgroundCheck(report:any) {
    report.last_activity = this.formatDate(report.last_activity);
    report.top_row = [
      { label: $localize`Requested by`, content: report.requested_by }
    ];
    if (report.product_permission) {
      report.check_name = this.MOBILE_ID_FLOWS.includes(report.check_name) ? `MobileID - ${report.check_name}` : report.check_name;
      if (report.check_short_name === ConstantsService.NCC_BANKRUPTCY_SHORT_NAME){
          report.check_name = 'Bankruptcy Check'
      }

      if(report?.sub_status?.purged){
        report.status = 'Purged'
      }
      report.tag_information = {
        hasTag: true,
        nestedStatTagText: '',
        tagText: this.getLabelByValue(report.status),
        status: report.status,
        tagCompleted: 0,
        tagTotal: 0,
        sub_status_tooltip: this.subStatusTooltips,
        sub_status: report?.sub_status,
      };
      report.view_info = {
        enabled: !!report?.report_url && this.canViewBackGroundReport && !report?.sub_status?.purged,
        hidden: false,
        btnText: $localize`View`
      }
    } else {
      this.setTagButtonInfoForNoPermissions(report);
    }
  }

  onViewExitReportDeprecated(id:string){
    this.router.navigate(['/report', id, this.profileParam]);
  }

  onViewExitReport(id:string, restricted: boolean){
    if(!restricted){
      this.router.navigate(['/report', id, this.profileParam]);
    }
  }

  onViewBackgroundReport(url:string, check_short_name:string, person_uid:string) {
    this.requestService.getPDFReport(url, check_short_name, person_uid.substring(0,8))
  }

  getCheckAndProviderNames(check_name: string, provider_name:string): string {
    return `${check_name} <span class="color-grey">(${provider_name})</span>`;
  }

  getBackgroundCheckName(check_name: string, provider_name: string, restricted: boolean): string {
    if (restricted){
      return ConstantsService.BACKGROUND_CHECK_RESTRICTED;
    }
    return `${check_name} <span class="color-grey">(${provider_name})</span>`;
  }

  onViewPulseReport(report:any){
    if(report.is_report_view_allowed){
    // Add log when clicked on pulse request
      const userdetails = this.permissions.hasxrpUserPermission();
      const metaData = {
        "log": {
          "user_id": userdetails['user_id'],
          "email": userdetails['email'],
          "name": userdetails['name'],
          "username": userdetails['username'],
          "message": "User clicked on pulse request " + report.uid
        },
        "audit_log": "CLICK_PULSE_REQUEST"
      };
      this.planService.postLog(metaData);
      const created = moment(report.check_created_at).format('ll')
      const state = {
        state: {
          'request': {
            id: report.check_id,
            name: report.check_name
          },
          'pulseStart': created,
          'pulseEnd': created
        }
      }
      this.router.navigateByUrl('/insights', state);
    }
  }

  getLabelByValue(value:string){
      if(this.TrustEIVC){
          this.STATUS_OPTIONS_CHECKS[13].label = $localize`Error`
      }
     return this.STATUS_OPTIONS_CHECKS.find(option => option.value == value)?.label;
  }

  getReportProfileStatus(profileStatus: string, report: any) {
    if (report?.activity_role === this.ActivityRole.Referee) {
      return 'Potential Candidate';
    }
    else if (report?.activity_role === this.ActivityRole.Candidate) {
      return 'Candidate';
    }
    return profileStatus;
  }

  processReport(report:any) {
    const { status, stats, has_questionnaire_permission: hasQuestionnairePermission } = report;
    const sumittedLessThanFive = stats.total_completed < 5;
    const isExpired = moment.utc(stats.expiry) < moment.utc(new Date());

    const isReportViewAllowed = this.isReportViewAllowed(status, sumittedLessThanFive, hasQuestionnairePermission);
    const tooltipText = this.generateTooltipText(status, sumittedLessThanFive, hasQuestionnairePermission);
    const isInsightsNotAvailable = this.isInsightsNotAvailable(status, sumittedLessThanFive, isExpired);

    return {
      isReportViewAllowed,
      tooltipText,
      isInsightsNotAvailable
    };
  }

  isReportViewAllowed(status:string, sumittedLessThanFive:boolean, hasQuestionnairePermission:boolean) {
    return this.COMPLETED_OR_STOPPED.includes(status) && !sumittedLessThanFive && hasQuestionnairePermission;
  }

  generateTooltipText(status: string, sumittedLessThanFive: boolean, hasQuestionnairePermission: boolean) {
    if (this.COMPLETED_OR_STOPPED.includes(status) && !sumittedLessThanFive) {
      return !hasQuestionnairePermission ?
        '' : $localize`Insights may not include feedback from this recipient`;
    }
    return '';

  }

   isInsightsNotAvailable(status:string, sumittedLessThanFive:boolean, isExpired:boolean) {
    return (status === 'Completed' && sumittedLessThanFive && isExpired) ||
      (status === 'Stopped' && sumittedLessThanFive);
  }

}
